import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteLocation } from '../Api'

export default generateApiAction({
  baseType: Types.LOCATIONS.DELETE,
  api: deleteLocation,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/locations/DeleteAction.js